import i18n from "@/langs/i18n";

export function getAll() {
  var items = [
    {
      value: 0,
      name: "Web",
      text: `${i18n.t("option.apiType.Web")}`,
    },
    {
      value: 1,
      name: "Broadcast",
      text: `${i18n.t("option.apiType.Broadcast")}`,
    },
    {
      value: 2,
      name: "Order",
      text: `${i18n.t("option.apiType.Order")}`,
    },
    {
      value: 3,
      name: "Member",
      text: `${i18n.t("option.apiType.Member")}`,
    },
    {
      value: 4,
      name: "OpenAPI",
      text: "OpenAPI",
    },
     {
      value: 5,
      name: "OpenAPIWebhook",
      text: "OpenAPIWebhook",
    },
  ];
  return items;
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
